import React from 'react';
import { Stack, Text } from '@moda/om';
import { RETURN_REASONS } from '../../../constants';
import { OrderItem } from '../../../hooks/useOrder';
import { OrderItemDetails } from '../OrderItemDetails';
import { OrderItemPrice } from '../OrderItemPrice';
import { OrderItemImage } from '../OrderItemImage';

import './ReturnOrderItem.scss';

interface Props {
  item?: OrderItem;
  showExtraDetails?: boolean;
}

export const ReturnOrderItem: React.FC<Props> = ({ item, showExtraDetails = false }) => {
  if (!item) return null;

  const returnReason = RETURN_REASONS.find(reason => {
    return item.attributes.refundReasonCode === reason.value;
  });

  return (
    <div className="ReturnOrderItem">
      <div className="ReturnOrderItem__content">
        <Stack className="ReturnOrderItem__main" space={3} direction="horizontal">
          <div className="ReturnOrderItem__image">
            <OrderItemImage item={item} imageSize="medium" />
          </div>
          <Stack space={3}>
            <OrderItemDetails item={item} showExtraDetails={showExtraDetails} />

            <OrderItemPrice item={item} layout="row" />
          </Stack>
        </Stack>
        <Stack className="ReturnOrderItem__reason" space={0}>
          <Text treatment="bold1">Return Reason:</Text>
          <Text color="cement">{returnReason ? returnReason.label : 'Other'}</Text>
        </Stack>
      </div>
    </div>
  );
};
